import { initCf7Validation } from './components/formsValidation'
import { initPhoneMask } from './components/phoneMask';
import { tabs } from './components/tabs';
import { faqAccordeon } from './components/faqAccordeon';

document.addEventListener('DOMContentLoaded', () => {
	try {
		initCf7Validation();
	}
	catch (e) {
		console.log(`initCf7Validation error ${e}`);
	}
	try {
		initPhoneMask();
	}
	catch (e) {
		console.log(`initPhoneMask error ${e}`);
	}
	try {
		tabs();
	}
	catch (e) {
		console.log(`tabs error ${e}`);
	}
	try {
		faqAccordeon();
	}
	catch (e) {
		console.log(`faqAccordeon error ${e}`);
	}

});